import { useEffect, useRef, useState } from "react"

import { PropTypes } from "@l2r-front/l2r-proptypes"

import { useIsMobileDevice } from "../../hooks/useIsMobileDevice"

import * as Styled from "./ScrollableLayout.styled"

export const ScrollableLayout = (props) => {
    const {
        buttons,
        className,
        content,
    } = props

    const scrollableRef = useRef(null)
    const [showShadow, setShowShadow] = useState(false)
    const isMobile = useIsMobileDevice()

    useEffect(() => {
        const checkScroll = () => {
            if (scrollableEl.scrollHeight > scrollableEl.clientHeight) {
                setShowShadow(scrollableEl.scrollTop + scrollableEl.clientHeight < scrollableEl.scrollHeight)
            } else {
                setShowShadow(false)
            }
        }

        const scrollableEl = scrollableRef.current
        if (!scrollableEl) {
            return
        }

        checkScroll()
        scrollableEl.addEventListener("scroll", checkScroll)
        window.addEventListener("resize", checkScroll)
        const observer = new MutationObserver(checkScroll)
        observer.observe(scrollableEl, {
            childList: true,
            subtree: true,
        })

        return () => {
            scrollableEl.removeEventListener("scroll", checkScroll)
            window.removeEventListener("resize", checkScroll)
            observer.disconnect()
        }
    }, [scrollableRef])

    return (
        <Styled.ScrollableLayoutContainer className={className}>
            <Styled.ContentContainer ref={scrollableRef}>
                {content}
            </Styled.ContentContainer>
            <Styled.ButtonsContainer showShadow={showShadow} isMobile={isMobile}>
                {buttons}
            </Styled.ButtonsContainer>
        </Styled.ScrollableLayoutContainer>
    )
}

ScrollableLayout.propTypes = {
    buttons: PropTypes.node.isRequired,
    className: PropTypes.string,
    content: PropTypes.node.isRequired,
}